import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modalContent"]

  connect() {
    this.modalContentTargets.forEach(modalElement => {
      const closeButton = document.createElement("button")
      closeButton.className = "p-special-cool_studio_location-modal__close"
      closeButton.dataset.action = `click->${this.identifier}#closeModal`
      closeButton.setAttribute("aria-label", "閉じる")
      modalElement.appendChild(closeButton)
    })
    this.backdropElement = document.createElement("div")
    this.backdropElement.className = "p-special-cool_studio_location-modal__backdrop"
    this.backdropElement.setAttribute(
      "data-action",
      "click->" + this.identifier + "#closeModal"
    )
    this.element.appendChild(this.backdropElement)
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener("keydown", this.boundCloseOnEscape)

    // Clarity用: URLパラメータとハッシュで自動モーダルオープン
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get("event") === "claritymodal" && window.location.hash.startsWith("#modal-")) {
      const modalName = window.location.hash.replace("#modal-", "")
      this.open({ params: { name: modalName } })
    }
  }

  disconnect() {
    this.backdropElement.remove()
    document.removeEventListener("keydown", this.boundCloseOnEscape)
    document.documentElement.classList.remove("u-noscroll")
    if (!this.isPC()) {
      document.body.classList.remove("u-noscroll")
    }
    const spHeader = document.querySelector(".l-header--sp")
    if (spHeader) {
      spHeader.classList.remove("is-header-hidden")
    }
    const globalNav = document.querySelector(".p-global-navigation")
    if (globalNav) {
      globalNav.classList.remove("is-global-navigation-hidden")
    }
  }

  // 開く
  open({ params: { name } }) {
    const targetModal = this.modalContentTargets.find(
      (modal) => modal.dataset.modalId === name
    )
    if (targetModal) {
      this.backdropElement.classList.add("is-active")
      targetModal.classList.add("is-active")
      document.documentElement.classList.add("u-noscroll")

      if (!this.isPC()) {
        document.body.classList.add("u-noscroll")
      }
      const spHeader = document.querySelector(".l-header--sp")
      if (spHeader) {
        spHeader.classList.add("is-header-hidden")
      }
      const globalNav = document.querySelector(".p-global-navigation")
      if (globalNav) {
        globalNav.classList.add("is-global-navigation-hidden")
      }

      // Clarity: モーダルトラッキングを更新
      const modalUrl = new URL(window.location.href)
      modalUrl.searchParams.set('event', 'claritymodal')
      modalUrl.hash = "modal-" + name
      history.pushState(null, '', modalUrl.toString())
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'modal', "modal-" + name)
      }
    }
  }

  // 閉じる
  closeModal() {
    const activeModal = this.modalContentTargets.find((modal) =>
      modal.classList.contains("is-active")
    )
    if (activeModal) {
      this.backdropElement.classList.remove("is-active")
      activeModal.classList.remove("is-active")
      document.documentElement.classList.remove("u-noscroll")
      if (!this.isPC()) {
        document.body.classList.remove("u-noscroll")
      }
      const spHeader = document.querySelector(".l-header--sp")
      if (spHeader) {
        spHeader.classList.remove("is-header-hidden")
      }
      const globalNav = document.querySelector(".p-global-navigation")
      if (globalNav) {
        globalNav.classList.remove("is-global-navigation-hidden")
      }
      // Clarity: URLからevent=claritymodalパラメータと#modal-xxxハッシュを削除
      const url = new URL(window.location.href)
      url.searchParams.delete("event")
      if (url.hash.startsWith("#modal-")) {
        url.hash = ""
      }
      history.replaceState(null, '', url.toString())
    }
  }
  stopPropagation(event) {
    event.stopPropagation()
  }

  // PC判定用メソッド
  isPC() {
    return !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  }

  // 念の為キーボード用
  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }
}
